export const APPROVALS_ROOT_URL = '/approvals';
